<template>
    <div class="career_planning">
        <div class="banner-head">
            <div class="banner-head-box">
                <div style="height: 254px;"></div>
                <div class="title">职业规划课程</div>
                <div style="height: 26px;"></div>
                <div class="txt">从认知觉醒到能力跃迁，四段课程覆盖职业全周期</div>
            </div>
        </div>
        <!--3小时--->
        <div class="three-hours" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-200">
            <div class="three-hours-box">
                <div class="content-box">
                    <div class="box-img">
                        <img src="../../assets/career_planning/three-hours.png" class="img"/>
                    </div>
                   <div class="content">
                    <div class="time">
                        <div class="duration">3</div>
                        <div style="width: 4px;"></div>
                        <div class="hour">小时</div>
                    </div>
                    <div style="height: 6px;"></div>
                    <div class="title">职业定位讲座</div>
                    <div style="height: 20px;"></div>
                    <div class="txt">专业实战型导师领航，助力学生拨开职业迷雾，精准定位未来方向！ 讲座聚焦职业认知与方向探索，引导学生深度剖析行业趋势，把握发展机遇；帮助学生科学评估自我优势，找准个人定位；并指导学生掌握高效简历撰写与面试制胜技巧。帮助学生告别迷茫，少走弯路，快速提升求职竞争力与职场适应力。</div>
                    <div style="height: 19px;"></div>
                    <div class="tags">
                        <div class="tag">职业认知</div>
                        <div class="tag">趋势洞察</div>
                        <div class="tag">优势挖掘</div>
                    </div>
                  </div>
                </div>
                
            </div>
        </div>

        <!--5个小时-->
        <div class="three-hours" style="background: rgb(249, 249, 249);" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-200">
            <div class="three-hours-box">
                <div class="content-box">
                   <div class="content">
                    <div class="time">
                        <div class="duration">5</div>
                        <div style="width: 4px;"></div>
                        <div class="hour">小时</div>
                    </div>
                    <div style="height: 6px;"></div>
                    <div class="title">觉醒工作坊</div>
                    <div style="height: 20px;"></div>
                    <div class="txt">
                        专业实战型导师领航，采用 “理论+实战”沉浸式教学模式。工作坊将引导学生通过权威性格测评，深度认知真实自我；指导其亲手绘制精准职业画像，锁定适配发展方向，帮助学生彻底颠覆模糊认知，建立清晰职业定位，系统掌握从自我探索、方向锚定到求职通关的核心能力，为其突破职业瓶颈、实现高质量就业或转型跃升提供强力引擎！
                    </div>
                    <div style="height: 19px;"></div>
                    <div class="tags">
                        <div class="tag">职业探索</div>
                        <div class="tag">方向锚定</div>
                        <div class="tag">求职技巧</div>
                    </div>
                  </div>
                  <div class="box-img">
                        <img src="../../assets/career_planning/five-hours.png" class="img"/>
                    </div>
                </div>
                
            </div>
        </div>


         <!--8周--->
        <div class="three-hours" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-200">
            <div class="three-hours-box">
                <div class="content-box">
                    <div class="box-img">
                        <img src="../../assets/career_planning/eight-hours.png" class="img"/>
                    </div>
                   <div class="content">
                    <div class="time">
                        <div class="duration">8</div>
                        <div style="width: 10px;"></div>
                        <div class="hour">周</div>
                    </div>
                    <div style="height: 6px;"></div>
                    <div class="title">蜕变训练营</div>
                    <div style="height: 20px;"></div>
                    <div class="txt">
                        采用 “线上+线下”混合模式，通过 八大核心主题模块，系统赋能学生职业发展全程。训练营不仅助力精准设计未来职业路线图、精通简历面试求职硬技能，更深度提升职场软实力、职业化思维与沟通素养，并传授快速融入策略与人脉构建心法。最终引导学生完成职业规划总结与未来展望，实现从求职准备到职场立足再到长远发展的全方位蜕变与竞争力跃升。
                    </div>
                    <div style="height: 19px;"></div>
                    <div class="tags">
                        <div class="tag">软硬技能熔炼</div>
                        <div class="tag">职场素养提升</div>
                        <div class="tag">人脉构建法则</div>
                    </div>
                  </div>
                </div>
                
            </div>
        </div>

         <!--5个小时-->
        <div class="three-hours" style="background: rgb(249, 249, 249);" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-offset="-200">
            <div class="three-hours-box">
                <div class="content-box">
                   <div class="content">
                    <div class="time">
                        <div class="duration">32</div>
                          <div style="width: 6px;"></div>
                        <div class="hour">节</div>
                    </div>
                    <div style="height: 6px;"></div>
                    <div class="title">职业系列课程</div>
                    <div style="height: 20px;"></div>
                    <div class="txt">
                        课程分层设计， 针对不同年级学生提供适配课程，系统性帮助学员应对AI时代的职业挑战与机遇。课程涵盖三大核心模块：分析未来10年行业趋势与人才需求；教授当前环境下的职业规划、优势发掘与发展策略；提供职业转型与求职落地的实用方法。还包含精选好书精讲，助力构建全领域知识体系，为学员在快速变化的职场中指明方向、制定策略并实现突破。
                    </div>
                    <div style="height: 19px;"></div>
                    <div class="tags">
                        <div class="tag">竞争力分析</div>
                        <div class="tag">职业罗盘制定</div>
                        <div class="tag">终身学习引擎</div>
                    </div>
                  </div>
                  <div class="box-img">
                        <img src="../../assets/career_planning/thirty-two-hours.png" class="img"/>
                    </div>
                </div>
                
            </div>
        </div>

        <contact-us/>
    </div>
</template>

<script>
import contactUs from '../../components/ContactUs/contactUs.vue'
export default {
    name: 'careerplanning',
    components:{
        contactUs
    },
    mounted(){
     window.scrollTo(0, 0);
    }
}
</script>

<style lang="scss" scoped>
.career_planning {
    .banner-head {
        width: 100%;
        height: 700px;
        background-image: url("../../assets/career_planning/banner-head.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;

        .banner-head-box {
            width: 1280px;
            height: 158px;
            margin: 0 auto;

            .title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 60px;
                color: #FF6E00;
                line-height: 66px;
                text-align: left;
                font-style: normal;
            }

            .txt {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 36px;
                color: #171A1D;
                line-height: 66px;
                text-align: left;
                font-style: normal;
            }
        }
    }

    .three-hours{
        height: 500px;
        width: auto;
        background: white;
        .three-hours-box{
            width: 1280px;
            height: 500px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .content-box{
                height: 354px;
                width: 1280px;
                display: flex;
                justify-content: space-between;
                 .content{
                    display: flex;
                    flex-direction: column;
                .tags{
                    width: 413px;
                    height: 36px;
                    display: flex;
                    justify-content: space-around;
                    .tag{
                        width: 131px;
                        height: 36px;
                        border-radius: 6px;
                        border: 1px solid #FF6E00;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FF6E00;
                        line-height: 36px;
                        text-align: center;
                        font-style: normal;
                    }
                }

                .title{
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 32px;
                    color: #171A1D;
                    line-height: 45px;
                    text-align: left;
                    font-style: normal;
                }
                .txt{
                    width: 650px;
                    height: 124px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: rgba(23,26,29,0.6);
                    line-height: 31px;
                    text-align: justify;
                    font-style: normal;
                }

                .time{
                    display: flex;
                    height: auto;
                    height: 100px;
                    .duration{
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 90px;
                        color: #FF6E00;
                        text-align: left;
                        font-style: normal;
                        margin-top: -10px;
                    }
                    .hour{
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 24px;
                        color: #FF6E00;
                        line-height: 33px;
                        text-align: left;
                        font-style: normal;
                        margin-top: 65px;
                    }
                }
            }
            .box-img{
                display: flex;
                align-items: flex-end;
                .img{
                width: 540px;
                height: 340px;
              }
            }
            
            }
           
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/career_planning/index.vue